var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438.03 304.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1uui119,.cls-2uui119,.uui119,.cls-4uui119{fill:none;}.cls-1uui119,.cls-5uui119,.cls-6uui119,.cls-7uui119{stroke-width:0px;}.cls-2uui119{stroke-dasharray:0 0 0 6;stroke-linecap:round;stroke-width:2px;}.cls-2uui119,.cls-8uui119,.uui119,.cls-4uui119{stroke-miterlimit:10;}.cls-2uui119,.cls-8uui119,.cls-4uui119{stroke:#004f68;}.cls-8uui119{fill:#f5faf9;}.uui119{stroke:#009ed9;stroke-width:4px;}.cls-5uui119{fill:#e1e8e7;}.cls-6uui119{fill:#fff;}.cls-7uui119{fill:#004f68;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1uui119",
    width: 438.03,
    height: 304.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8uui119",
    x: 153.46,
    y: 34.7,
    width: 115.22,
    height: 214.86,
    rx: 15.09,
    ry: 15.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7uui119",
    d: "m190.63,34.7h41.25v7.64c0,2.73-2.22,4.95-4.95,4.95h-31.36c-2.73,0-4.95-2.22-4.95-4.95v-7.64h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5uui119",
    x: 171.55,
    y: 60.17,
    width: 81.97,
    height: 81.97,
    rx: 4.64,
    ry: 4.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4uui119",
    x1: 173.95,
    y1: 172.23,
    x2: 235.73,
    y2: 172.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4uui119",
    x1: 173.95,
    y1: 187.73,
    x2: 222.15,
    y2: 187.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4uui119",
    x1: 173.95,
    y1: 158.73,
    x2: 248.65,
    y2: 158.73
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uui119",
    points: "174.84 203.97 199.71 228.85 281.94 146.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6uui119",
    x: 189.33,
    y: 95.85,
    width: 46.4,
    height: 35.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6uui119",
    points: "212.53 75.83 180.55 97.84 244.52 97.84 212.53 75.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4uui119",
    points: "244.52 97.84 212.53 75.83 180.55 97.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7uui119",
    x: 204.43,
    y: 106.87,
    width: 16.2,
    height: 24.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 298.14,
    y1: 137.84,
    x2: 390.21,
    y2: 137.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 130.69,
    y1: 140.21,
    x2: 38.62,
    y2: 140.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 296.91,
    y1: 85.22,
    x2: 348.2,
    y2: 52.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 298.14,
    y1: 191.25,
    x2: 351.88,
    y2: 225.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 131.92,
    y1: 192.82,
    x2: 80.64,
    y2: 225.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 130.69,
    y1: 86.8,
    x2: 76.95,
    y2: 52.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 306.66,
    y1: 112.24,
    x2: 364,
    y2: 95.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 308.04,
    y1: 165.02,
    x2: 368.13,
    y2: 182.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 122.17,
    y1: 165.81,
    x2: 64.83,
    y2: 182.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui119",
    x1: 120.79,
    y1: 113.02,
    x2: 60.7,
    y2: 95.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationSubmitted);
export default __webpack_public_path__ + "static/media/application-submitted.c9ec209789973dd5a53a7d4cde6f3784.svg";
export { ForwardRef as ReactComponent };